var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_1712)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08474 0.334735C1.53105 -0.111578 2.25467 -0.111578 2.70098 0.334735L8.75 6.38376L14.799 0.334735C15.2453 -0.111578 15.969 -0.111578 16.4153 0.334735C16.8616 0.781049 16.8616 1.50467 16.4153 1.95098L9.55812 8.80812C9.11181 9.25444 8.38819 9.25444 7.94188 8.80812L1.08474 1.95098C0.638422 1.50467 0.638422 0.781049 1.08474 0.334735Z",
    fill: "#18191F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_1712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.d0ff554e2d6a45e02bd314ee53f59d8f.svg";
export { ForwardRef as ReactComponent };